export default "__VITE_ASSET__CIWJMU_J__"